import React, { useEffect, useContext } from 'react'
import Context from '../context/ModalContext'
import AuthContext from '../context/AuthContext'

import styled from 'styled-components'

const Link = styled.a`
    align-items: center;
    justify-content: space-between;
    display: flex;
    padding: 16px 0;
    width: 100%;

    color: inherit;
    cursor: pointer;

    transition: color .1s ease-in-out;
`;

const Button = styled(Link)``;

const DownloadLink = ({title, href}) => {

    const loginContext = useContext(AuthContext);
    const authcontext = useContext(AuthContext);
    const setAuth = () => {
        loginContext.updateLoginMode();
    };
    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (localStorage.getItem('isLogin') === '1' && !authcontext.data.loginMode) {
                setAuth();
            }
        }
    });

    return (
        <>
            <AuthContext.Consumer>
                {(authcontext) => authcontext.data.loginMode ? 
                    <Link href={href} target="_blank" rel="noopener noreferrer">
                        <span>{title}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><g fill="none" fillRule="evenodd" stroke="#5AE4AA"><path strokeWidth="2" d="M8 6.111V0v6.111m5.5 0l-5.5 5.5-5.5-5.5m5.5 0V11 6.111z"/><path d="M0 15.5h16H0z"/></g></svg>
                    </Link>
                 : 
                    <Context.Consumer>
                        {context => (
                        <Button onClick={context.updateModalMode}>
                            <span>{title}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><g fill="none" fillRule="evenodd" stroke="#5AE4AA"><path strokeWidth="2" d="M8 6.111V0v6.111m5.5 0l-5.5 5.5-5.5-5.5m5.5 0V11 6.111z"/><path d="M0 15.5h16H0z"/></g></svg>
                        </Button>
                        )}
                    </Context.Consumer>
                }
            </AuthContext.Consumer>
        </>
    )
};

export default DownloadLink;